module.exports = __webpack_public_path__ + "media/img/vca/prizes/onthelist-2f06c11cad161a2ae8f2b3b20e84843f.png";